import{getDefaultExportFromCjs as r}from"./_commonjsHelpers.mjs";import{__require as o}from"../node_modules/prop-types/index.mjs";var p=o();const s=r(p);export{s as default};
